module.exports = __webpack_public_path__ + "img/900.6f88eed7.png";